import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const styles = {
  tooltip: ({ palette, breakpoints, spacing }) => ({
    position: 'relative',
    maxWidth: 100,
    padding: spacing(1, 1.5),
    borderRadius: 2,
    backgroundColor: palette.colors.darkBlue,
    color: palette.common.white,
    [breakpoints.up('md')]: {
      maxWidth: 150,
    },
    [breakpoints.up('lg')]: {
      maxWidth: 250,
    },
  }),
};

export const SingleValueTooltip = ({ active = false, payload = [] }) => {
  if (!active || !payload) {
    return null;
  }

  return (
    <Box sx={styles.tooltip}>
      <Typography variant="caption" component="p" color="inherit">
        {payload[0]?.payload?.name} - {payload[0]?.value}
      </Typography>
    </Box>
  );
};

SingleValueTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
      payload: PropTypes.shape({
        name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    }),
    PropTypes.bool,
  ),
};
